import type { VFrameBase } from '@festina/life-general-types/life'
import type { Merge, Optional } from '@festina-life/core'
import { type FormikStatusType, useFormikContext } from '@festina-life/ui/hooks'
import type { FormikContextType } from 'formik'

/**
 * This type will disappear once `LifeLazyForm` fully takes over `LifeForm`'s place.
 */
export type LifeStatusType = Merge<
  FormikStatusType,
  {
    frame?: Optional<VFrameBase> | false
    fieldVFrame?: (name: string) => Optional<VFrameBase>
  }
>

type LifeFormikContext<T> = Merge<
  FormikContextType<T>,
  {
    status: LifeStatusType
    setStatus: (status: LifeStatusType) => void
  }
>

// Technically we don't need to entirely kill this file. We could keep it as a do-nothing re-export. But that feels unnecessary.
/**
 * Custom implementation of useFormikContext to ensure that status is typed.
 *
 * This function will disappear once `LifeLazyForm` fully takes over `LifeForm`'s place.
 */
export const useLifeFormikContext = <T>() => {
  const formikContext = useFormikContext<T>()

  return formikContext as unknown as LifeFormikContext<T>
}
